const ServiceData = [{
        id: "farmly",
        category: "서비스",
        title: "Farmly · 주말농장 서비스",
        summary: "웹과 Android 앱에서 이용할 수 있는 자체 주말농장 서비스입니다.",
        body: "Farmly는 주말농장 이용을 위한 자체 서비스입니다. 웹 서비스를 운영하고 있으며, Android 앱도 프로덕션에 배포하여 제공하고 있습니다.",
        role: "자체 서비스 개발 및 운영",
        status: "운영 중",
        hashtag: ["#Web", "#App", "#Android", "#서비스"],
        img: "./images/division_section/smart_farm1.jpg",
        logo: "./images/division_section/smart_farm1.jpg",
        alt: "주말농장 서비스 소개 이미지",
        links: [
            { label: "Farmly 웹 서비스", url: "https://farmly.click" },
            { label: "서비스 소개", url: "https://farmly.click/landing.html" }
        ]
    }
];

export default ServiceData;
